import ImagePickerInput from '../Common/ImagePickerInput';

const ImagePickerInputWrapper = objProps => {
  return <ImagePickerInput {...objProps.field} {...objProps} />;
};

export default ImagePickerInputWrapper;
